import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: 'form', // this will apply to all <form> elements automatically
  standalone: true
})
export class DisableAutocompleteDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', 'off');
    this.renderer.setAttribute(this.el.nativeElement, 'autocorrect', 'off');
    this.renderer.setAttribute(this.el.nativeElement, 'spellcheck', 'false');
  }
}
